import { render, staticRenderFns } from "./travelListItem.vue?vue&type=template&id=240f062f"
import script from "./travelListItem.vue?vue&type=script&lang=ts"
export * from "./travelListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports